<template>
    <section class="list-items-section">
        <div class="fe-btn-translation" @click="$root.$emit('open_modal_translation', 'Not Allowed', arrayTranslations)" v-if="globalTranslate">OPEN TRANSLATION</div>

        <div class="group_items">
            <div class="space-left"></div>
            <div class="empty-row full">
                <div class="icon">
                    <img src="/build/icons/not-allowed.svg">
                </div>
                <div class="title">
                    {{$t('not-allowed.title')}}
                </div>
                <div class="description narrow">
                    {{$t('not-allowed.description')}}
                </div>
                <div class="add-button">
                    <router-link class="button-tbf-blue" :to="{name: 'dashboard' }">{{$t('not-allowed.button')}}</router-link>
                </div>
            </div>
            <div class="space-right"></div>
        </div>
    </section>
</template>

<script>

    export default {
        data(){
            return{
                arrayTranslations: [
                    'not-allowed.title',
                    'not-allowed.description',
                    'not-allowed.button'
                ]
            }
        },
        components: {
        },
        methods: {
        }
    }
</script>